export default __webpack_public_path__ + "static/media/hero-goal.866cd34e.svg";